module.exports = __webpack_public_path__ + "static/img/after-sale-lynx-0.333f84c0.png";